/*********************** Custom JS for Boost AI Search & Discovery ************************/

// Function to add SKU to each product
function addSku(element, isGridView) {
  // Get product data & product item
  let productData = element.getParams().props.product;
  let productId = productData.id;
  if (productData?.split_product) {
    productId = productData.variant_id;
  }
  let productItem = document.querySelector('[data-product-id="' + productId + '"]');
  if (!productItem) return;

  // Add SKU only if it doesn't already exist
  if (productData?.skus[0]) {
    const skuHTML = `<span class="boost-sd-sku product-sku"><strong>SKU</strong> ${productData.skus[0]}</span>`;
    if (!productItem.querySelector('.boost-sd-sku')) {
      productItem.querySelector('.boost-sd__product-title')?.insertAdjacentHTML('afterend', skuHTML);
    }
  }
}

// Function to add St. Patrick's Day Banner below each Add to Cart button
function addStPatricksBanner() {
  if (window.location.href.includes("/collections/st-patricks-day-sale")) {
    let wrappers = document.querySelectorAll(".boost-sd__product-list-grid--4-col .boost-sd__product-info");
    wrappers.forEach(btn => {
      if (!btn.nextElementSibling || !btn.nextElementSibling.classList.contains("st-patricks-sale-banner")) {
        let banner = document.createElement("div");
        banner.className = "st-patricks-sale-banner";
        banner.innerHTML = `
          <span class="st-sale">
            <img class="leaf4" src="https://cdn.shopify.com/s/files/1/1963/2399/files/4leafs.svg?v=1741223354" alt="4 Leaf Clover">
            Special St. Patrick's Day Discount!<br> 
            <span class="applied">Applied At Checkout</span>
          </span>`;
        banner.style.cssText = "color: #2B602F; text-align: left; font-size:12px; margin-top: 10px;";
        btn.insertAdjacentElement("afterend", banner);
      }
    });
  }
}

// Function to append “.00” to whole-dollar Boost prices
function formatPrices() {
  document.querySelectorAll('.boost-sd__format-currency span').forEach(el => {
    const txt = el.textContent.trim();
    if (/^\$\d+$/.test(txt)) {
      el.textContent = txt + '.00';
    }
  });
}

// Run on initial load
if (document.readyState !== 'loading') {
  formatPrices();
} else {
  document.addEventListener('DOMContentLoaded', formatPrices);
}

// Observe for any DOM/Ajax changes and re-run
new MutationObserver(formatPrices)
  .observe(document.body, { childList: true, subtree: true });


// Boost AI Search & Discovery customization registry
const customize = {
  customizeProductItem: (componentRegistry) => {
    const updateProductItemGridView = {
      name: 'Add percent sale badge grid view',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          addSku(element, true);
          addStPatricksBanner();
          formatPrices();
        }
      })
    };

    const updateProductItemListView = {
      name: 'Add percent sale badge list view',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          addSku(element);
          addStPatricksBanner();
          formatPrices();
        }
      })
    };

    componentRegistry.useComponentPlugin('ProductItem', updateProductItemGridView);
    componentRegistry.useComponentPlugin('ProductItemListViewLayout', updateProductItemListView);
  }
};

// Ensure Boost's customization array exists and append ours
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? [])
  .concat([customize.customizeProductItem]);
